import { differenceInYears, isValid, parseISO } from "date-fns";

const isAdult = (dateOfBirth: string | Date, adultAge = 18): boolean => {
  const d =
    typeof dateOfBirth === "string" ? parseISO(dateOfBirth) : dateOfBirth;
  if (!isValid(d)) return false;
  return differenceInYears(new Date(), d) >= adultAge;
};

export default isAdult;
